import React from 'react'
import PropTypes from 'prop-types'
import { styled } from '@mui/material/styles'
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip'

export const HtmlTooltip = styled(({ className, ...props }) => <Tooltip {...props} classes={{ popper: className }} />)(
  ({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: '#333',
      color: '#EAEAEA',
      maxWidth: 550,
      fontSize: theme.typography.pxToRem(12),
      border: '1px solid #555'
    }
  })
)

HtmlTooltip.displayName = 'HtmlTooltip'

HtmlTooltip.propTypes = {
  className: PropTypes.string
}
